import moment from "moment";

export const today = moment().format('YYYY-MM-DD');
